import React from 'react'
import styled from 'styled-components'
import { Divider } from '@olxbr/ds-web'
import { System } from '@olxbr/olx-icons'
import { Skeleton } from '../../atoms'
import { CircularIntegerProgress, SkeletonAnimation } from '../../molecules'

const ProgressCircleWrapper = styled.div`
  width: var(--spacing-8);
  height: var(--spacing-8);
`

const AwardIcon = styled(System.Award)`
  color: ${({ color }) => color};
`

export const LevelProgressSkeleton = () => (
  <SkeletonAnimation>
    <div className="flex flex-1 items-center">
      <ProgressCircleWrapper>
        <CircularIntegerProgress
          strokeWidth={8}
          steps={4}
          stepsCompleted={4}
          styles={{
            path: {
              strokeLinecap: 'butt',
              stroke: 'var(--color-neutral-100)',
            },
          }}
        >
          <AwardIcon color={'var(--color-neutral-100)'} />
        </CircularIntegerProgress>
      </ProgressCircleWrapper>
      <div className="flex flex-1 flex-col items-start ml-3">
        <Skeleton type="label" />
        <Divider inverted marginBottom="--spacing-0-5" />
        <Skeleton />
      </div>
    </div>
  </SkeletonAnimation>
)
